"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rejectExtraOptions = void 0;
const dynamoDBToolboxError_js_1 = require("../errors/dynamoDBToolboxError.js");
const rejectExtraOptions = (extraOptions) => {
    const [extraOption] = Object.keys(extraOptions);
    if (extraOption !== undefined) {
        throw new dynamoDBToolboxError_js_1.DynamoDBToolboxError('options.unknownOption', {
            message: `Unknown option: ${extraOption}.`,
            payload: { option: extraOption }
        });
    }
};
exports.rejectExtraOptions = rejectExtraOptions;
